<template>
  <WCSinglePageFormContainer>
    <WCRecoverPasswordForm @submit="submit" />
  </WCSinglePageFormContainer>
</template>

<script>
import axios from 'axios';
import WCSinglePageFormContainer from '@/modules/forms/components/WCSinglePageFormContainer/WCSinglePageFormContainer.vue';
import ToastService from '@/modules/toasts/services/ToastService';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';
import WCRecoverPasswordForm from '../../components/WCRecoverPasswordForm/WCRecoverPasswordForm.vue';

export default {
  components: { WCSinglePageFormContainer, WCRecoverPasswordForm },
  props: {
    token: {
      type: String,
    },
  },
  async created() {
    this.loading = true;

    try {
      await axios.get(`api/password-reset/${this.token}`);
    } catch (error) {
      /* Token expired. Restart password recovery process. */
      const response = error.response;
      const message =
        response && response.data && response.data.message
          ? response.data.message
          : 'Token expired. Try resetting your password again.';
      ToastService.open(WCSimpleToast, {
        props: {
          variant: 'danger',
          title: 'Error',
          message,
        },
        timeout: 7000,
      });
      // TODO: Vue 3 handle router errors
      this.$router.replace({ name: 'ForgotPassword' }).catch(() => {});
    } finally {
      this.loading = false;
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    // Check if the user is logging in via scan mode
    isCustomerModeScan() {
      return this.$route.query.scan === 'true';
    },
  },
  methods: {
    async submit(form) {
      try {
        const payload = {
          password: form.password,
        };
        let requestPayload = payload;
        if (this.isCustomerModeScan) {
          requestPayload = { ...payload, scan: true };
        }
        await axios.post(`api/password-reset/${this.token}`, requestPayload);
        // TODO: Vue 3 handle router errors
        if (this.isCustomerModeScan) {
          this.$router.push({ name: 'Scan Products' });
        } else this.$router.push({ name: 'Home' }).catch(() => {});
      } catch (error) {
        console.error(error);
        const response = error.response;
        const message =
          response && response.data && response.data.message
            ? response.data.message
            : 'Token expired. Try resetting your password again.';
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: 'Error',
            message,
          },
          timeout: 7000,
        });
        // TODO: Vue 3 handle router errors
        this.$router.replace({ name: 'ForgotPassword' }).catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
